// TINTeDe theme JS
(function(){
  // ---- Harta transparențelor (VLT ascendent) + descrieri ----
  var SHADES = {
    1:  { op: .96, name: 'SUPER DARK BLACK 1%',  desc: 'Look complet negru, maximă intimitate — din exterior nu se vede nimic.' },
    5:  { op: .88, name: 'DARK BLACK 5%',        desc: 'Foarte închis, aspect VIP — intimitate ridicată, un plus de vizibilitate față de 1%.' },
    15: { op: .7,  name: 'BLACK 15%',            desc: 'Echilibru ideal zi / noapte — fumuriu clasic, vizibilitate bună din interior.' },
    35: { op: .45, name: 'LIGHT BLACK 35%',      desc: 'Fumuriu discret pentru daily — filtrează soarele fără să schimbe radical aspectul.' }
  };
  function shadeFor(vlt){
    if (SHADES[vlt]) return SHADES[vlt];
    return { op: Math.min(.96, Math.max(.3, (100 - vlt) / 100)), name: 'VLT ' + vlt + '%', desc: '' };
  }
  function applyShadePreview(vlt, label){
    var s = shadeFor(vlt);
    var photo = document.querySelector('[data-shade-photo]');
    if (photo){
      var host = photo.closest('[data-photo-15]');
      var src = host ? host.dataset['photo-' + vlt] : null;
      if (src) photo.src = src;
    }
    var tint = document.querySelector('[data-tint]');
    var vltEl = document.querySelector('[data-vlt]');
    var nmEl = document.querySelector('[data-shade-name]');
    if (tint) tint.style.opacity = s.op;
    if (vltEl) vltEl.textContent = 'VLT ' + vlt + '%';
    if (nmEl) nmEl.textContent = label || s.name;
  }

  // ---- Demo nuanțe (homepage hero) ----
  document.querySelectorAll('.shade-picker').forEach(function(picker){
    picker.querySelectorAll('.shade-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        picker.querySelectorAll('.shade-btn').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');
        applyShadePreview(parseInt(btn.dataset.vltVal), btn.dataset.name);
      });
    });
  });

  // ---- Bază vehicule: make-model.json din assets, cu fallback la textarea ----
  function parseFallback(text){
    var db = {};
    (text || '').split('\n').forEach(function(line){
      var parts = line.split('|');
      if (parts.length === 2) db[parts[0].trim()] = parts[1].split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    });
    return db;
  }
  function normalizeJson(data){
    var db = {};
    if (Array.isArray(data)) {
      data.forEach(function(row){
        var make = row.make || row.marca || row.brand || row.Marca || row.Make;
        if (!make) return;
        var models = row.models || row.modele || row.Models;
        if (Array.isArray(models)) { db[make] = (db[make] || []).concat(models); return; }
        var model = row.model || row.Model;
        if (model) { (db[make] = db[make] || []).push(model); }
      });
    } else if (data && typeof data === 'object') {
      Object.keys(data).forEach(function(k){
        var v = data[k];
        if (Array.isArray(v)) db[k] = v.map(String);
        else if (v && Array.isArray(v.models || v.modele)) db[k] = (v.models || v.modele).map(String);
      });
    }
    Object.keys(db).forEach(function(k){
      db[k] = Array.from(new Set(db[k].map(function(m){ return String(m).trim(); }).filter(Boolean))).sort();
    });
    return db;
  }
  function loadVehicleDb(box){
    var url = box.dataset.vehicleJson;
    var fallback = parseFallback(box.dataset.vehicleFallback);
    if (!url) return Promise.resolve(fallback);
    return fetch(url).then(function(r){
      if (!r.ok) throw new Error('missing');
      return r.json();
    }).then(function(data){
      var db = normalizeJson(data);
      return Object.keys(db).length ? db : fallback;
    }).catch(function(){ return fallback; });
  }

  // ---- Selectoare vehicul (homepage + produs) ----
  var VKEY = 'tintede_vehicle';
  function readSavedVehicle(){
    try { return JSON.parse(localStorage.getItem(VKEY) || 'null'); } catch(e){ return null; }
  }
  function writeSavedVehicle(o){
    try { localStorage.setItem(VKEY, JSON.stringify(o)); } catch(e){}
  }
  document.querySelectorAll('[data-vehicle-box]').forEach(function(box){
    var selMarca = box.querySelector('[data-sel-marca]');
    var selModel = box.querySelector('[data-sel-model]');
    var manual = box.querySelector('[data-model-manual]');
    var prop = box.querySelector('[data-vehicle-property]');
    var go = box.querySelector('[data-sel-go]');
    var result = box.querySelector('[data-sel-result]');
    if (!selMarca) return;

    loadVehicleDb(box).then(function(db){
      var makes = Object.keys(db).sort();
      makes.forEach(function(m){
        var o = document.createElement('option'); o.value = o.textContent = m; selMarca.appendChild(o);
      });

      var msgSel = box.dataset.msgSelected || '✓ Mașina selectată:';
      var msgSuf = box.dataset.msgSuffix || '— apare pe comandă';
      var lblModel = box.dataset.labelModel || 'Alege modelul';
      function populateModels(make){
        selModel.innerHTML = '<option value="">' + lblModel + '</option>';
        (db[make] || []).forEach(function(m){
          var o = document.createElement('option'); o.value = o.textContent = m; selModel.appendChild(o);
        });
        selModel.disabled = !make;
      }
      function vehicleValue(){
        if (manual && manual.value.trim()) return manual.value.trim();
        if (selMarca.value && selModel.value) return selMarca.value + ' ' + selModel.value;
        return '';
      }
      function sync(save){
        var v = vehicleValue();
        if (prop) prop.value = v;
        if (result) result.innerHTML = v ? msgSel + ' <strong>' + v + '</strong> ' + msgSuf : '';
        if (go) go.disabled = !v;
        if (save !== false) writeSavedVehicle({ marca: selMarca.value, model: selModel.value, manual: manual ? manual.value.trim() : '' });
      }

      selMarca.addEventListener('change', function(){
        populateModels(selMarca.value);
        if (manual && selMarca.value) manual.value = '';
        sync();
      });
      selModel.addEventListener('change', function(){
        if (manual && selModel.value) manual.value = '';
        sync();
      });
      if (manual) manual.addEventListener('input', function(){
        if (manual.value.trim()){
          selMarca.value = ''; populateModels(''); selModel.disabled = true;
        }
        sync();
      });
      if (go) go.addEventListener('click', function(){
        window.location.href = box.dataset.target || '/collections/all';
      });

      // restaurare: mașina aleasă anterior se precompletează automat
      var saved = readSavedVehicle();
      if (saved){
        if (saved.manual && manual){
          manual.value = saved.manual;
        } else if (saved.marca && db[saved.marca]){
          selMarca.value = saved.marca;
          populateModels(saved.marca);
          if (saved.model) selModel.value = saved.model;
        }
      }
      sync(false);
    });
  });

  // ---- Pagina de produs ----
  var pdp = document.querySelector('[data-product]');
  if (pdp){
    var qty = pdp.querySelector('[data-qty]');
    var minus = pdp.querySelector('[data-qty-minus]');
    var plus = pdp.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value)||1) - 1); });
    if (plus) plus.addEventListener('click', function(){ qty.value = (parseInt(qty.value)||1) + 1; });

    var variants = [];
    try { variants = JSON.parse(pdp.dataset.variants || '[]'); } catch(e){}
    var groups = pdp.querySelectorAll('.opt-group');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var addBtn = pdp.querySelector('[data-add]');

    var priceMap = {};
    try {
      var pmEl = pdp.querySelector('[data-variant-prices]');
      if (pmEl) priceMap = JSON.parse(pmEl.textContent);
    } catch(e){}
    function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' lei'; }
    function selectedOptions(){
      var out = [];
      groups.forEach(function(g){
        var active = g.querySelector('.opt-btn.is-active');
        out[parseInt(g.dataset.optionIndex)] = active ? active.dataset.value : null;
      });
      return out;
    }
    function syncVariant(){
      if (variants.length && groups.length){
        var sel = selectedOptions();
        var match = variants.find(function(v){
          return sel.every(function(val, i){ return val === null || v.options[i] === val; });
        });
        if (match){
          if (idInput) idInput.value = match.id;
          var pm = priceMap[String(match.id)];
          if (priceEl) priceEl.textContent = pm ? pm.price : money(match.price);
          if (compareEl){
            var cmp = pm ? pm.compare : (match.compare_at_price && match.compare_at_price > match.price ? money(match.compare_at_price) : null);
            if (cmp){ compareEl.textContent = cmp; compareEl.style.display = ''; }
            else compareEl.style.display = 'none';
          }
          var avail = pm ? pm.available : match.available;
          if (addBtn && !addBtn.dataset.holdText){
            addBtn.disabled = !avail;
            addBtn.textContent = avail ? (addBtn.dataset.textAdd || 'Comandă setul pentru mașina ta') : (addBtn.dataset.textSoldout || 'Stoc epuizat');
          }
        }
      }
      // Descriere + previzualizare pentru opțiunea de transparență
      groups.forEach(function(g){
        var name = g.dataset.optionName || '';
        if (/transparen|nuan/i.test(name)){
          var active = g.querySelector('.opt-btn.is-active');
          var descEl = g.nextElementSibling && g.nextElementSibling.hasAttribute('data-option-desc') ? g.nextElementSibling : null;
          if (!active){ if (descEl) descEl.style.display = 'none'; return; }
          var m = (active.dataset.value || '').match(/(\d+)\s*%/);
          if (!m) return;
          var vlt = parseInt(m[1]);
          var s = shadeFor(vlt);
          applyShadePreview(vlt, active.dataset.value);
          if (descEl && s.desc){ descEl.textContent = s.desc; descEl.style.display = 'block'; }
        }
      });
    }
    groups.forEach(function(g){
      g.querySelectorAll('.opt-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          g.querySelectorAll('.opt-btn').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          syncVariant();
        });
      });
    });
    syncVariant();

    // Validare la trimitere: mașina e obligatorie (din liste sau manual)
    var form = pdp.querySelector('form[action*="/cart/add"]');
    var vehErr = pdp.querySelector('[data-vehicle-error]');
    if (form){
      form.addEventListener('submit', function(e){
        var prop = pdp.querySelector('[data-vehicle-property]');
        if (prop && !prop.value.trim()){
          e.preventDefault();
          if (vehErr) vehErr.style.display = 'block';
          var box = pdp.querySelector('[data-vehicle-box]');
          if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (vehErr) vehErr.style.display = 'none';
      });
    }
  }

  // ---- Formular retur multi-pas (Web3Forms) ----
  var rf = document.getElementById('retur-form');
  if (rf){
    var steps = rf.querySelectorAll('.rf-step');
    var dots = rf.querySelectorAll('.rf-dot');
    var current = 1;
    function show(n){
      current = n;
      steps.forEach(function(s){ s.classList.toggle('is-active', parseInt(s.dataset.step) === n); });
      dots.forEach(function(d){ d.classList.toggle('is-active', parseInt(d.dataset.dot) <= n); });
      if (n === 4) buildSummary();
      rf.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function validate(stepEl){
      var ok = true;
      stepEl.querySelectorAll('[data-req]').forEach(function(inp){
        if (!inp.value.trim()){ ok = false; inp.style.borderColor = '#f0a63c'; }
        else inp.style.borderColor = '';
      });
      stepEl.querySelectorAll('[data-req-group]').forEach(function(gr){
        if (!gr.querySelector('input:checked')) ok = false;
      });
      var ramburs = stepEl.querySelector('input[value="Ramburs bani"]:checked');
      if (ramburs){
        var iban = stepEl.querySelector('input[name="IBAN"]');
        if (iban && !iban.value.trim()){ ok = false; iban.style.borderColor = '#f0a63c'; }
      }
      var err = stepEl.querySelector('[data-error]');
      if (err) err.style.display = ok ? 'none' : 'block';
      return ok;
    }
    rf.querySelectorAll('[data-next]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var stepEl = btn.closest('.rf-step');
        if (validate(stepEl)) show(current + 1);
      });
    });
    rf.querySelectorAll('[data-prev]').forEach(function(btn){
      btn.addEventListener('click', function(){ show(current - 1); });
    });
    rf.querySelectorAll('input[name="Soluție preferată"]').forEach(function(radio){
      radio.addEventListener('change', function(){
        rf.querySelectorAll('.rf-cond').forEach(function(c){ c.style.display = 'none'; });
        var t = radio.dataset.show;
        if (t){ var el = rf.querySelector('[data-cond="' + t + '"]'); if (el) el.style.display = 'block'; }
      });
    });
    var photos = rf.querySelector('[data-photos]');
    if (photos){
      photos.addEventListener('change', function(){
        var lbl = rf.querySelector('[data-photos-label]');
        var files = Array.from(photos.files);
        if (files.length > 3){
          photos.value = '';
          if (lbl) lbl.textContent = 'Maxim 3 fișiere — alege din nou.';
          return;
        }
        if (lbl) lbl.textContent = files.length ? files.map(function(f){ return f.name; }).join(', ') : 'JPG, PNG — max. 3 fișiere, ~5MB total';
      });
    }
    function buildSummary(){
      var out = [];
      rf.querySelectorAll('input, select, textarea').forEach(function(f){
        if (!f.name || ['access_key','subject','from_name','botcheck','attachment'].indexOf(f.name) !== -1) return;
        if (f.type === 'radio' && !f.checked) return;
        if (f.type === 'checkbox' || f.type === 'file' || f.type === 'hidden') return;
        if (!f.value.trim()) return;
        out.push('<div style="padding:8px 0;border-bottom:1px solid var(--linie)"><span style="color:var(--ceata)">' + f.name + ':</span> ' + f.value + '</div>');
      });
      var box = rf.querySelector('[data-summary]');
      if (box) box.innerHTML = out.join('');
    }
    var sendBtn = rf.querySelector('[data-send]');
    if (sendBtn) sendBtn.addEventListener('click', function(){
      var errEl = rf.querySelector('[data-send-error]');
      if (errEl) errEl.style.display = 'none';
      sendBtn.disabled = true;
      var orig = sendBtn.textContent;
      sendBtn.textContent = 'Se trimite...';
      var fd = new FormData(rf);
      fetch('https://api.web3forms.com/submit', { method: 'POST', body: fd })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data.success){
            rf.querySelector('[data-form-body]').style.display = 'none';
            rf.querySelector('[data-form-success]').style.display = 'block';
            rf.scrollIntoView({ behavior: 'smooth' });
          } else { throw new Error('fail'); }
        })
        .catch(function(){
          if (errEl) errEl.style.display = 'block';
        })
        .finally(function(){
          sendBtn.disabled = false;
          sendBtn.textContent = orig;
        });
    });
    show(1);
  }
})();

// ---- Sticky add-to-cart (pagina de produs) ----
(function(){
  var bar = document.querySelector('[data-sticky-atc]');
  var pdp = document.querySelector('[data-product]');
  if (!bar || !pdp) return;
  var mainBtn = pdp.querySelector('[data-add]');
  var form = pdp.querySelector('form[action*="/cart/add"]');
  var stickyBtn = bar.querySelector('[data-sticky-add]');
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var priceEl = pdp.querySelector('[data-price]');
  if (mainBtn && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(mainBtn);
  }
  if (stickyBtn && form){
    stickyBtn.addEventListener('click', function(){
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }
  if (stickyPrice && priceEl){
    new MutationObserver(function(){ stickyPrice.textContent = priceEl.textContent; })
      .observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
})();

// ---- Reveal on scroll ----
(function(){
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('.prod-card,.benefit,.step,.shade-card,.review,.hiw-step,.value,.trust-cell');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 });
  els.forEach(function(el){ el.classList.add('reveal'); io.observe(el); });
})();
